module.exports = __webpack_public_path__ + "src/components/Menu/assets/net-3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Menu/assets/net-3.svg
// module id = 2921
// module chunks = 14